<template>
  <div class="carousel-editor">
    <el-form ref="form" :model="form" label-width="180px" label-position="left">
      <!-- <el-form-item :label="$t('microSite.carousel.label.moduleName')">
        <el-input v-model="form.moduleName" :placeholder="$t('microSite.carousel.placeHolder.enterModuleName')"></el-input>
      </el-form-item> -->
      <!-- <el-form-item :label="$t('microSite.carousel.label.showSearchBox')">
        <SwitchButtton v-model="form.isShowSearchBox" :options="showSearchBoxOptions"></SwitchButtton>
      </el-form-item> -->
      <el-form-item prop="interval" :label="$t('microSite.carousel.label.switchInterval')">
        <el-input
          v-model="form.interval"
          type="number"
        >
          <template #append>{{ $t('microSite.carousel.label.microsecond') }}</template>
        </el-input>
      </el-form-item>
      <el-form-item class="size-config" :label="$t('microSite.carousel.label.imageWidth')">
        <SwitchButton v-model="form.size.width.type" :options="sizeOptions.width"></SwitchButton>
        <el-slider
          v-if="form.size.width.type === SIZE_TYPE.SCREEN_PERCENTAGE"
          v-model="form.size.width.percentage"
          show-input
          :min="1"
          :max="100"
        ></el-slider>
        <el-input
          v-if="form.size.width.type === SIZE_TYPE.FIXED"
          v-model="form.size.width.fixed"
          type="number"
        >
          <template #append>px</template>
        </el-input>
      </el-form-item>
      <el-form-item class="size-config" :label="$t('microSite.carousel.label.imageHeight')">
        <SwitchButton v-model="form.size.height.type" :options="sizeOptions.height"></SwitchButton>
        <el-slider
          v-if="form.size.height.type === SIZE_TYPE.SCREEN_PERCENTAGE"
          v-model="form.size.height.percentage"
          show-input
          :min="1"
          :max="100"
        ></el-slider>
        <el-input
          v-if="form.size.height.type === SIZE_TYPE.FIXED"
          v-model="form.size.height.fixed"
          type="number"
        >
          <template #append>px</template>
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('microSite.carousel.label.bgImage')">
        <ImageUpload v-model="form.backgroudImages" :otherTips="uploadTip"></ImageUpload>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import _ from 'lodash'
import editorTemplate from '../editorTemplate'
import ImageUpload from '../../components/editor/imageUpload.vue'
import SwitchButton from '../../components/editor/switchButton.vue'
import { SIZE_TYPE } from '../renderMixin'

export default {
  components: {
    ImageUpload,
    SwitchButton
  },
  mixins: [editorTemplate],
  data () {
    return {
      form: {
        title: null,
        subTitle: null,
        interval: 5000,
        size: {
          width: {
            type: SIZE_TYPE.FIXED,
            fixed: null,
            percentage: null
          },
          height: {
            type: SIZE_TYPE.AUTO,
            fixed: null,
            percentage: null
          }
        },
        isShowSearchBox: false
      },
      showSearchBoxOptions: [
        {
          labelI18nKey: 'microSite.carousel.radio.show',
          value: true
        },
        {
          labelI18nKey: this.$t('microSite.carousel.radio.hide'),
          value: false
        }
      ]
    }
  },
  computed: {
    uploadTip () {
      if (this.isMobile) {
        return this.$t('microSite.carousel.imageTips')
      } else {
        return this.$t('microSite.component.upload.suggestion', { size: '1366*584' })
      }
    }
  },
  created () {
    const props = _.cloneDeep(this.renderData.data.props)
    if (props) {
      this.form.title = props.title
      this.form.subTitle = props.subTitle
      this.form.backgroudImages = props.backgroudImages
      this.form.isShowSearchBox = props.isShowSearchBox
      this.form.interval = props.interval || 5000
      const size = props.size
      this.form.size = {
        width: {
          type: size?.width?.type || (this.isMobile ? SIZE_TYPE.SCREEN_PERCENTAGE : SIZE_TYPE.FIXED),
          fixed: size?.width?.fixed || (this.isMobile ? 375 : 1366),
          percentage: size?.width?.percentage || 100
        },
        height: {
          type: size?.height?.type || SIZE_TYPE.AUTO,
          fixed: size?.height?.fixed || 300,
          percentage: size?.height?.percentage || 30
        }
      }
    }
  },
  methods: {
    validateAndUpdateRenderData () {
      let result = false
      this.$refs.form.validate(valid => { result = valid })
      if (!result) {
        return result
      }
      const props = this.renderData.data.props
      props.title = this.form.title
      props.subTitle = this.form.subTitle
      props.backgroudImages = this.form.backgroudImages
      props.isShowSearchBox = this.form.isShowSearchBox
      props.interval = this.parseToInt(this.form.interval)
      const size = this.form.size
      this.$set(props, 'size', {
        width: {
          type: size.width.type,
          fixed: this.parseToInt(size.width.fixed),
          percentage: this.parseToInt(size.width.percentage)
        },
        height: {
          type: size.height.type,
          fixed: this.parseToInt(size.height.fixed),
          percentage: this.parseToInt(size.height.percentage)
        }
      })

      if (Object.prototype.hasOwnProperty.call(props, 'isAutoImageHeight')) {
        delete props.isAutoImageHeight
      }
      this.updateConfigInRoot()
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
.carousel-editor {
  .size-config {
    .el-slider {
      margin-top: 15px;
    }
    .el-input {
      margin-top: 15px;
    }
  }

  ::v-deep {
    .el-input__inner[type="number"] {
      appearance: textfield;
      &::-webkit-inner-spin-button {
        appearance: none;
      }
    }
  }
}
</style>
